import React, { Component, Fragment } from 'react';
import ArrowIcon from '@tencent/docs-design-resources/pc/svg/icon_thirdary_arrow_fill_right.svg';
import styles from './arrow-tips.less';

export enum EArrowDirection {
    up,
    down,
    left,
    right,
}

export interface IArrowTipsProps {
    left: number;
    top: number;
    message: string;
    direction: EArrowDirection;
}

export class ArrowTips extends Component<IArrowTipsProps> {
    constructor(props: IArrowTipsProps) {
        super(props);
    }

    public render() {
        return <div
            className={`${styles.tipsContainer}
             ${this.isRightLeft(this.props.direction) ? styles.leftRightContainer : styles.upDownContainer}`}
            style={{
                transform: `translate(calc(${this.props.left}px - 50%), calc(${this.props.top}px - 50%))`,
                flexDirection: this.getFlexCssByDirection(this.props.direction),
            }}
        >
            { this.renderContent(this.props.message, this.props.direction) }
        </div>;
    }

    private isRightLeft(direction: EArrowDirection) {
        return direction === EArrowDirection.right || direction === EArrowDirection.left;
    }

    /**
     * 方向映射flex的css
     * @param direction
     * @private
     */
    private getFlexCssByDirection(direction) {
        switch (direction) {
            case EArrowDirection.up:
                return 'column-reverse';
            case EArrowDirection.down:
                return 'column';
            case EArrowDirection.left:
                return 'row-reverse';
            case EArrowDirection.right:
                return 'row';
            default:
                return 'row';
        }
    }

    /**
     * 根据方向渲染文字、icon
     * @param text
     * @param direction
     * @private
     */
    private renderContent(text, direction) {
        if (this.isRightLeft(direction)) {
            return <Fragment>
                <div
                    style={{
                        width: '37px',
                        height: '18px',
                        lineHeight: '18px',
                        textAlign: 'center',
                    }}
                >
                    { text }
                </div>
                <div
                    className={styles.arrowHorzContainer}
                >
                    <img
                        className={styles.arrowIcon}
                        style={{
                            transform: `rotate(${direction === EArrowDirection.left ? 180 : 0}deg)`,
                        }}
                        src={ArrowIcon}/>
                </div>
            </Fragment>;
        }
        return <Fragment>
            <div
                style={{
                    width: '100%',
                    height: '17px',
                    textAlign: 'center',
                    padding: '0 0 4px 0',
                }}
            >
                { text }
            </div>
            <div
                className={styles.arrowVertContainer}
            >
                <img
                    className={styles.arrowIcon}
                    style={{
                        transform: `rotate(${direction === EArrowDirection.up ? 270 : 90}deg)`,
                    }}
                    src={ArrowIcon}/>
            </div>
        </Fragment>;
    }
}
